<template>
    <app-page-content>
        <Title text="Área Administrativa" />
        <router-view></router-view>
    </app-page-content>
</template>
<script>
    import Title from '../UI/Layout/Title.vue';
    import PageContent from '../UI/Layout/PageContent.vue';
    import AdministrativeMenu from './AdministrativeMenu.vue';

    export default {
        components: {
            appPageContent: PageContent,
            appTitle: Title,
            appAdministrativeMenu: AdministrativeMenu
        }
    }
</script>